import React from 'react';

interface IconListItemProps {
  alt?: string;
  children: React.ReactNode;
}

export const IconListItem: React.FC<IconListItemProps> = ({
  alt = '',
  children,
}) => {
  return (
    <li className="flex items-start gap-1">
      <img
        src="/images/icons/check-li.png"
        alt={alt}
        className="w-5 h-5 mt-1 mr-0"
      />
      {children}
    </li>
  );
};
